<template>
    <form class="form-horizontal modal_content" @submit.prevent="store()">
        <div class="col-xs-12 has-error" v-if="errors['general']">
            <div class="alert alert-danger">{{ errors['general'][0] }}</div>
        </div>
        <div class="row">
            <div class="col-sm-6 m-b-15" :class="{'has-error': errors['first_name']}">
                <label>{{ $t('first_name') }}</label>
                <input type="text" class="form-control" v-pml-focus v-model="record.first_name">
                <span class="error" v-if="errors['first_name']">{{ errors['first_name'][0] }}</span>
            </div>
            <div class="col-sm-6 m-b-15" :class="{'has-error': errors['last_name']}">
                <label>{{ $t('last_name') }}</label>
                <input type="text" class="form-control" v-model="record.last_name">
                <span class="error" v-if="errors['last_name']">{{ errors['last_name'][0] }}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 m-b-15" :class="{'has-error': errors['email']}">
                <label>{{ $t('email') }}</label>
                <input type="text" class="form-control" v-model="record.email">
                <span class="error" v-if="errors['email']">{{ errors['email'][0] }}</span>
            </div>
            <div class="col-sm-6 m-b-15" :class="{'has-error': errors['default_language']}">
                <label>{{ $t('default_language') }}</label>
                <pml-select v-model="record.default_language" :options="languages"></pml-select>
                <span class="error" v-if="errors['default_language']">{{ errors['default_language'][0] }}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 clearfix">
                <router-link :to="{ name: 'company.members' }" class="btn btn-white btn_na">{{ $t('cancel') }}</router-link>
                <button type="submit" class="btn btn-default pull-right" v-pml-block="isSaving">{{ $t('save') }}</button>
            </div>
        </div>
    </form>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { create } from 'services/members'
    import { mapGetters } from 'vuex'

    export default {
        name: 'MemberForm',
        data () {
            return {
                isSaving: false,
                record: {},
                errors: []
            }
        },
        computed: {
            ...mapGetters({
                languages: 'getLanguages'
            })
        },
        methods: {
            store () {
                this.isSaving = true

                create(this.record)
                    .then(() => {
                        Notify.success(trans('member_added_successfully_he_will_receive_activation_email'))
                        this.$router.push({ name: 'company.members' })
                    })
                    .catch(error => { this.errors = error.response.data.errors || [] })
                    .then(() => { this.isSaving = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/company/components/members/Form.vue